const englishText = require("../data/UI-ENG.json")

export function getTranslation(translations, language, type, ref, key) {
  // console.log(translations, language, type, ref, key)
  if (translations) {
    if (translations[language] && translations[language][type]) {
      if (key) {
        if (
          translations[language][type][ref][key] &&
          translations[language][type][ref][key] !== "translation"
        ) {
          return translations[language][type][ref][key]
        } else if (translations.ENG && translations.ENG[type][ref][key]) {
          return translations.ENG[type][ref][key]
        }
        return englishText[type][ref][key]
      } else {
        if (
          translations[language][type][ref] &&
          translations[language][type][ref] !== "translation"
        ) {
          return translations[language][type][ref]
        } else if (translations.ENG && translations.ENG[type][ref]) {
          return translations.ENG[type][ref]
        }
        return englishText[type][ref]
      }
    }
    if (key) {
      if (translations.ENG && translations.ENG[type][ref][key]) {
        return translations.ENG[type][ref][key]
      }
      return englishText[type][ref][key]
    } else {
      if (translations.ENG && translations.ENG[type][ref]) {
        return translations.ENG[type][ref]
      }
      return englishText[type][ref]
    }
  }
  if (key) {
    return englishText[type][ref][key]
  } else {
    return englishText[type][ref]
  }
}
